<div class="is-flex align-center height-100-pct">
    <div class="has-text-centered width-100-pct">
        <div>You do not have access to this page</div>
        <a (click)="goHome()">To return home click here</a>
    </div>
</div>